import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FaRegTimesCircle } from 'react-icons/fa';

export default function LegalModal({ show, onClose, title, children }) {
  return (
    <AnimatePresence>
      {show && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="fixed inset-0 bg-black/60 backdrop-blur-sm z-50 flex items-center justify-center px-4"
        >
          <motion.div
            initial={{ scale: 0.95, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            exit={{ scale: 0.95, opacity: 0 }}
            transition={{ duration: 0.35 }}
            className="bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 text-white max-w-3xl w-full p-8 rounded-3xl shadow-2xl relative border border-purple-600/30"
          >
            {/* Close Button */}
            <button
              onClick={onClose}
              className="absolute top-4 right-5 text-gray-400 hover:text-white text-2xl"
              aria-label="Close"
            >
              <FaRegTimesCircle />
            </button>

            {/* Header */}
            <h2 className="text-3xl font-extrabold mb-6 text-center bg-gradient-to-r from-purple-400 to-pink-500 text-transparent bg-clip-text tracking-tight">
              {title}
            </h2>

            {/* Content Area */}
            <div className="text-sm text-gray-200 space-y-6 max-h-[65vh] overflow-y-auto pr-2 custom-scrollbar">
               {children}
            </div>

          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
